var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconChevronLeft = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M14.0303 14.9698C14.3228 15.2623 14.3228 15.7378 14.0303 16.0303C13.7378 16.3228 13.2623 16.3228 12.9698 16.0303L8.46976 11.5303C8.17726 11.2378 8.17726 10.7623 8.46976 10.4698L12.9698 5.96975C13.2623 5.6765 13.7378 5.6765 14.0303 5.96975C14.3228 6.263 14.3228 6.73775 14.0303 7.03025L10.0605 11L14.0303 14.9698Z", fill: "black" }))),
        alt: 'Icon ChevronLeft',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconChevronLeft;
//# sourceMappingURL=index.js.map